import React from "react";
import "./PortfolioSummary.css";

const PortfolioSummary = ({ portfolio, selectedContract }) => {
  const { cash, positions } = portfolio;

  return (
    <div className="portfolio-summary-container">
      <h2>Portfolio Summary</h2>

      <div className="portfolio-balance-section">
        <div className="balance-card">
          <div className="balance-title">Total Cash</div>
          <div className="balance-amount">
            ${cash.total ? cash.total.toFixed(2) : "0.00"}
          </div>
        </div>

        <div className="balance-card">
          <div className="balance-title">Available Cash</div>
          <div className="balance-amount">
            ${cash.unlocked ? cash.unlocked.toFixed(2) : "0.00"}
          </div>
        </div>

        <div className="balance-card">
          <div className="balance-title">Locked in Orders</div>
          <div className="balance-amount">
            ${cash.locked ? cash.locked.toFixed(2) : "0.00"}
          </div>
        </div>
      </div>

      <h3>Positions</h3>
      {Object.keys(positions).length > 0 ? (
        <div className="positions-grid">
          {Object.entries(positions).map(([symbol, position]) => (
            <div
              key={symbol}
              className={`position-card ${
                symbol === selectedContract ? "active" : ""
              }`}>
              <div className="position-header">{symbol}</div>
              <div
                className={`position-value ${
                  position.total > 0
                    ? "positive"
                    : position.total < 0
                    ? "negative"
                    : ""
                }`}>
                {position.total > 0 ? "+" : ""}
                {position.total.toFixed(8)}
              </div>
              <div className="position-locked">
                Locked:{" "}
                {position.locked ? position.locked.toFixed(8) : "0.00000000"} |
                Available:{" "}
                {position.unlocked
                  ? position.unlocked.toFixed(8)
                  : "0.00000000"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-positions">No open positions</div>
      )}
    </div>
  );
};

export default PortfolioSummary;
